var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-group row mt-4",
      attrs: { role: "group", "aria-labelledby": _vm.title }
    },
    [
      _c("plain-text-control", {
        staticClass: "col-xs-12 col-sm-5",
        attrs: { id: _vm.title, title: _vm.title, required: _vm.required }
      }),
      _vm._v(" "),
      _c("ValidationProvider", {
        attrs: { rules: { required: _vm.required }, slim: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              var failedRules = ref.failedRules
              return [
                _c("div", { staticClass: "col-xs-12 col-sm-7" }, [
                  _c(
                    "div",
                    {
                      class: [
                        "radio-checkbox-group",
                        _vm.getValidationErrorClasses(failedRules)
                      ]
                    },
                    [
                      _c(
                        "div",
                        _vm._l(_vm.options, function(option) {
                          return _c(
                            "div",
                            { key: option.id },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedValues,
                                    expression: "selectedValues"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  name: _vm.title,
                                  id: option.name + option.id,
                                  disabled: _vm.isReadOnly,
                                  "aria-disabled": _vm.isReadOnly,
                                  "aria-invalid":
                                    !_vm.isReadOnly && errors.length > 0
                                },
                                domProps: {
                                  value: option.id,
                                  checked: Array.isArray(_vm.selectedValues)
                                    ? _vm._i(_vm.selectedValues, option.id) > -1
                                    : _vm.selectedValues
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$a = _vm.selectedValues,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = option.id,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.selectedValues = $$a.concat([
                                              $$v
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.selectedValues = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.selectedValues = $$c
                                      }
                                    },
                                    function($event) {
                                      return _vm.cleanIfNeededAndSave(option)
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("label-control", {
                                attrs: {
                                  forElement: option.name + option.id,
                                  title: option.name
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }